const $ = jQuery,
    RES = window.RES

const __ = key => RES.__('cf7', key)

export default class ContactForm7 {
    constructor($root) {
        // available events:
        // beforesubmit|submit|invalid|unaccepted|spam|aborted|mailsent|mailfailed
        this.root = $root
        this.responseBox = this.root.find('.wpcf7-response-output')

        this.loader = $(`
          <div class="wpcf7-loader-wrapper">
            <div class="wpcf7-loader">
              <div class="outerCircle"></div>
              <div class="innerCircle"></div>
            </div>
          </div>
        `)

        this.successMessage = $(`
          <div class="wpcf7-success s-invisible">
            <i class="fa-regular fa-check" aria-hidden="true"></i>
            <p>${__('success_message')}</p>
            <button>${__('send_another_one')}</button>
          </div>
        `)
        this.successMessage.find('button').on('click', () => {
            this.root.removeClass('s-sent')
            this.responseBox.empty()
        })

        this.root.append(this.loader)
        this.root.append(this.successMessage)

        this.root.on('wpcf7:beforesubmit', this.onBeforeSubmit.bind(this))
        this.root.on('wpcf7:submit', this.onSubmit.bind(this))
        this.root.on('wpcf7:mailsent', this.onSuccess.bind(this))

        this.root.find('.wpcf7-acceptance').each((i, a) => {
            $(a).find('input').wrap('<label></label>').after(`<span></span>`)
        })

        let interestSelect = this.root.find('select[name="product-interest"]');
        let robotsSelect = this.root.find('select[name="demolition-robots"]');
        let robotsSelectWrapper = robotsSelect.closest('.f');
        let attachmentsSelect = this.root.find('select[name="attachments"]');
        let attachmentsSelectWrapper = attachmentsSelect.closest('.f');

        if (interestSelect) {
            interestSelect.on('change', () => {
                if (interestSelect.val() === 'Demolition Robots') {
                    robotsSelectWrapper.css('display', 'block');
                    attachmentsSelectWrapper.css('display', 'none');
                    attachmentsSelect.val('');
                } else if (interestSelect.val() === 'Attachments') {
                    robotsSelectWrapper.css('display', 'none');
                    attachmentsSelectWrapper.css('display', 'block');
                    robotsSelect.val('');
                } else {
                    robotsSelectWrapper.css('display', 'none');
                    attachmentsSelectWrapper.css('display', 'none');
                    attachmentsSelect.val('');
                    robotsSelect.val('');
                }
            })
        }
    }

    onBeforeSubmit() {
        this.root.addClass('s-submitting')
    }

    onSubmit() {
        this.root.removeClass('s-submitting')
    }

    onSuccess() {
        this.root.addClass('s-sent')
    }
}
